export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7384.789b4632.jpg";